import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

import { computed, defineAsyncComponent, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import BottomNav from '@/shared/components/navigation/BottomNav.vue'
import { useModalStore } from '@/shared/stores/modal'
import { useAppStore } from '@/shared/stores/app'
import { getAppModeFromEnv } from './shared/utils/appMode'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const GlobalModal = defineAsyncComponent(() => import('@/shared/components/feedback/GlobalModal.vue'))
const GlobalSnackbar = defineAsyncComponent(() => import('@/shared/components/feedback/GlobalSnackbar.vue'))

const route = useRoute()
const modal = useModalStore()
const appStore = useAppStore()
const HIDE_BOTTOM_NAV_ROUTES = new Set<string>([
  'marketplace.inspection-form',
  'marketplace.recurring-form',
  'marketplace.free-estimation.form',
  'marketplace.schedule-form',
  'join-as-vendor.form',
  'customer.messages.detail',
  'customer.quotations.detail',
  'vendor.profile-setup',
  'vendor.quotations.detail',
  'provider.appointment.survey',
  'provider.appointment.saved-templates',
  'signup.page',
  'vendor.apply-company-memberships',
  'vendor.messages.detail',
  'vendor.quotation.template.detail'

])

const showBottomNav = computed(() => {
  const routeName = typeof route.name === 'string' ? route.name : ''
  const hiddenByRoute = HIDE_BOTTOM_NAV_ROUTES.has(routeName)
  const hiddenByFullscreenModal = modal.isOpen && modal.options.fullscreen
  return !hiddenByRoute && !hiddenByFullscreenModal
})

onMounted(async () => {
  await appStore.loadAppInit()

  if (appStore.status === 'error') {
    localStorage.clear()
    await appStore.loadAppInit(true)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ]),
        _: 1
      }),
      _createVNode(_unref(GlobalModal)),
      (showBottomNav.value)
        ? (_openBlock(), _createBlock(BottomNav, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_unref(GlobalSnackbar))
    ]),
    _: 1
  }))
}
}

})